module.exports = __webpack_public_path__ + "img/pop-up-vn-30.b6be0156.png";